import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { CmsQueryList } from '@fcom/core-api';

@Component({
  selector: 'fin-related-teaser',
  templateUrl: './related-teaser.component.html',
  styleUrls: ['./related-teaser.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class RelatedTeaserComponent {
  linkClicked = output<void>(); // mainly for click tracking if normal link tracking is not enough
  relatedTeaser = input<CmsQueryList>();

  emitClick(): void {
    this.linkClicked.emit();
  }
}
